export default __webpack_public_path__ + "static/media/refresh_bulk.609cb40c.svg";